jQuery(function($){
	$(document).ready(function(e){
        $(".pageIframes").each(function(){
			$('#'+$(this).attr('id')).on('load', function () {
                $('.iframe-loading-img').fadeOut('slow');
            });
			iFrameResize({ log: false, autoResize:true, inPageLinks: true }, '#'+$(this).attr('id'))
		})
    })
})

document.querySelectorAll('.gsp-menu-link.gsp-menu-has-children').forEach(link => {
    link.addEventListener('click', function(e) {
        // 1. Check if viewport is under 992px
        const isMobileBreakpoint = window.matchMedia('(max-width: 991.98px)').matches;
        if (!isMobileBreakpoint) return;

        // 2. Check if the href attribute is exactly "#"
        if (this.getAttribute('href') !== '#') return;

        const caret = this.querySelector('.caret');
        
        // 3. Prevent infinite loop if click originated inside the caret itself
        if (caret && !caret.contains(e.target)) {
            e.preventDefault(); 
            caret.click();      
        }
    });
});
